export default "__VITE_ASSET__edc58380__"